import { createContext } from 'react';

// How many Modals wrap the current component. 0 on a plain page.
export const ModalDepthContext = createContext(0);
